export default __webpack_public_path__ + "static/media/jm.450d0689.svg";